import {Card} from 'platform/components';
import {Box, Show} from 'platform/foundation';
import {css} from 'styled-components';

import i18n from '@dms/i18n';
import {CreateTypeOfControlSettingsRequestBody, useFormRenderer} from '@dms/teas';

const VALIDATION_OR_NON_VALIDATION_INSPECTION_TYPES = [
  CreateTypeOfControlSettingsRequestBody.inspectionType.VALIDATION_INSPECTION,
  CreateTypeOfControlSettingsRequestBody.inspectionType.NON_VALIDATION_INSPECTION,
];

interface AuditSettingsInspectionHeaderProps {
  inspectionType: CreateTypeOfControlSettingsRequestBody['inspectionType'];
}

export const AuditSettingsInspectionHeader = (props: AuditSettingsInspectionHeaderProps) => {
  const {Field} = useFormRenderer();

  return (
    <Box paddingBottom={4}>
      <Card>
        <Show when={VALIDATION_OR_NON_VALIDATION_INSPECTION_TYPES.includes(props.inspectionType)}>
          <Field
            name="validationInspection"
            label={i18n.t`page.vehicleSettings.labels.validationInspection`}
            as="checkbox"
          />
        </Show>
        <Field
          name="showEmptyFields"
          label={i18n.t`page.vehicleSettings.labels.dontDisplayInDC`}
          as="checkbox"
        />
        <div
          css={css`
            margin-bottom: -16px;
          `}
        >
          <Field label={i18n.t`entity.condition.labels.inspectionName`} name="name" required />
        </div>
      </Card>
    </Box>
  );
};
